import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { ENGLISH } from './lang/en/english';
import { SPANISH } from './lang/es/spanish';
import { FRENCH } from './lang/fr/french';
import { PORTUGUESE } from './lang/pt/portuguese';
export const autoLanguageDetector = () => {
  const currentlang = navigator.language;
  switch (currentlang.split('-')[0]) {
    case 'fr':
      return 'fr';
    case 'en':
      return 'en';
    case 'es':
      return 'es';
    case 'pt':
      return 'pt';
    default:
      return 'en';
  }
};
const detectionOptions = {
  order: ['path', 'cookie', 'navigator', 'localStorage'],
  lookupFromPathIndex: 0,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: autoLanguageDetector(),
    interpolation: {
      escapeValue: false,
    },
    detection: detectionOptions,
    resources: {
      en: {
        translation: ENGLISH,
      },
      es: {
        translation: SPANISH,
      },
      fr: {
        translation: FRENCH,
      },
      pt: {
        translation: PORTUGUESE,
      },
    },
  });

export default i18n;
